import React from "react";
import { PriceCard } from "./card";
import { ServiceData as data } from "../../data";
import { isMobile } from "react-device-detect"
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export const Pricing = () => {
    let settings = {}

    if (isMobile) {
        settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }
    else {
        settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        };
    }

    return (
        <section className="pricing" id="pricing">
            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-heading">
                            <h2>стоимость  услуг</h2>
                        </div>
                    </div>
                </div>

                <Slider centerPadding="30px"
                    {...settings}
                >
                    {
                        data.map((value, idx) => {
                            return (
                                <PriceCard
                                    key={idx}
                                    content={value.content}
                                />
                            )
                        })
                    }
                </Slider>

                <div className="add-info">
                    <span className="add-info-header">Дополнительные услуги (при необходимости): </span>
                    <div className="add-info-section">
                        <p>
                            Выезд в салон-магазин или на объект: 5000 руб./выезд.
                        </p>
                        <p>Однократный выезд в любой салон-магазин, торговый центр, текстильную мастерскую, на производство мебели
                            т.д. для подбора мебели, ее элементов, отделки, освещения, декоративных предметов, выбор текстиля, отделочных материалов и т.д. (3-4 часа рабочего времени).
                        </p>
                        <p>
                            Дополнительно оговаривается увеличение стоимости при большой удаленности и сложности объекта.
                        </p>
                    </div>
                    <div className="add-info-section">
                        <p>
                            Авторский надзор оплачивается отдельно.
                        </p>
                        <p>
                            Авторский надзор – это контроль соответствия реализации проекту, консультации, выезды в магазины-салоны. Заключается отдельный договор. Стоимость: от 50 000
                            руб./месяц, дополнительно оговаривается увеличение стоимости при большой удаленности и сложности объекта. Не более 4 выездов на объект и 2 выездов в салонымагазины (3-4 часа рабочего времени).
                        </p>
                    </div>
                    <div className="add-info-section">
                        <p>
                            Обмер оплачивается отдельно (от 15 000 р.).
                        </p>
                        <p>
                            Условия обмера, точная стоимость зависит от площади, сложности и удаленности объекта (уточняется по запросу)
                        </p>
                    </div>
                </div>

                <div className="links">
                    <a href="assets/docs/pricing2026.pdf" target="_blank" rel="noopener noreferrer">
                        Скачать информацию об услугах (PDF)
                    </a>
                </div>
            </div>

        </section >
    )
}